<template>
  <div class="xlntData" v-if="cgInfo">
    <div class="xlntCont">
      <div class="date_item" v-if="cgInfo.month_connect">
        <p class="nums">{{ cgInfo.month_connect }}</p>
        <p class="texts">安全连接时间 (min)</p>
      </div>
      <div class="date_item" v-if="cgInfo.total_install">
        <p class="nums">{{ cgInfo.total_install }}</p>
        <p class="texts">下载次数</p>
      </div>
      <div class="date_item" v-if="cgInfo.total_user">
        <p class="nums">{{ cgInfo.total_user }}</p>
        <p class="texts">用户支持数</p>
      </div>
      <div class="date_item" v-if="cgInfo.total_enterprise">
        <p class="nums">{{ cgInfo.total_enterprise }}</p>
        <p class="texts">企业用户合作数</p>
      </div>
    </div>
  </div>  
</template>
<script>
export default {
  props:{
    cgInfo: {
      type: Object,
      default: null
    }
  },
}
</script>
<style lang="less" scoped>
// 指数
.xlntData{
  background-color: #fff;
  .xlntCont{
    width: 100%;
    min-height: 109px;
    box-sizing: border-box;
    padding: 30px 20px;
    display: flex;
    flex-wrap: wrap;
    .date_item {
      flex: 1;
      .nums {
        width: 100%;
        color: #2E3237;
        text-align: center;
        font-family: PingFang SC;
        font-size: 22px;
        font-weight: 400;
        line-height: normal; 
      }
      .texts {
        width: 100%;
        margin-top: 1px;
        color: #747576;
        text-align: center;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
      }
    }
  }
}
</style>
